import { render, staticRenderFns } from "./StoragesOrders.vue?vue&type=template&id=054aeb5c&lang=true"
import script from "./StoragesOrders.vue?vue&type=script&lang=js"
export * from "./StoragesOrders.vue?vue&type=script&lang=js"
import style0 from "./StoragesOrders.vue?vue&type=style&index=0&id=054aeb5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports